export default IconTextDecrease => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-text-decrease" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 19v-10.5a3.5 3.5 0 1 1 7 0v10.5" />
  <path d="M4 13h7" />
  <path d="M21 12h-6" />
</svg>`;